import React from "react";
import { Col } from "react-bootstrap";
import { ClassResponse } from "../services/api.response.service";
import { AppState } from "../services/app.service";
import ClassCard from "./ClassCard";
import Languages from "./Languages";
import { RouteEndpoints } from "../services/route.service";

interface Props {
  title?: string;
  fullTitle?: string;
  data: Array<ClassResponse>;
  state: AppState;
}

function ClassesCardVList({ title, fullTitle, data, state }: Props) {
  return (
    <Col lg={12} className="row m-0 p-0">
      {(title || fullTitle) && (
        <Col sm={12} className="d-flex justify-content-between mt-1">
          <div className="header-title">
            <h4 className="card-title text-capitalize">
              {fullTitle && fullTitle!}
              {title && <Languages langKey={title} />}
            </h4>
          </div>
        </Col>
      )}
      <Col sm={12} className="row m-0 p-0 ">
        {data.map((item, i) => (
          <Col
            key={item.id}
            className={
              "mt-1 col-12 col-sm-6 col-md-4 col-lg-2 content-grid-col-md-lg-mid-split"
            }
          >
            <ClassCard data={item} />
          </Col>
        ))}
      </Col>
    </Col>
  );
}

export default ClassesCardVList;
